module.exports = __webpack_public_path__ + "static/img/智能巡检自主运行.a6d985a9.png";